// The call window's title bar (drag handle when floating): name, elapsed time, people, Speaker/Gallery, pop out,
// minimize.
import { useEffect, useState } from 'react';
import { LayoutGrid, Minus, PictureInPicture2, ShieldCheck, UserSquare2, Users } from 'lucide-react';

function Elapsed({ since }) {
  const [now, setNow] = useState(Date.now());
  useEffect(() => { const id = setInterval(() => setNow(Date.now()), 1000); return () => clearInterval(id); }, []);
  if (!since) return null;
  const s = Math.max(0, Math.floor((now - since) / 1000));
  const hh = Math.floor(s / 3600);
  const mm = String(Math.floor((s % 3600) / 60)).padStart(2, '0');
  const ss = String(s % 60).padStart(2, '0');
  return <span className="font-mono text-xs font-medium tracking-tight text-slate-300" data-testid="mm-elapsed">{hh ? `${hh}:` : ''}{mm}:{ss}</span>;
}

const seg = (on) => `flex h-7 items-center gap-1.5 rounded-md px-2.5 text-xs font-medium transition-colors duration-150 ${on ? 'bg-white/15 text-white' : 'text-slate-400 hover:text-white'}`;
const iconBtn = 'flex h-7 w-7 items-center justify-center rounded-md text-slate-300 transition-colors duration-150 hover:bg-white/10 hover:text-white disabled:cursor-not-allowed disabled:opacity-35';

export default function TitleBar({ title, since, people, view, setView, onMinimize, pop, dragProps, narrow }) {
  return (
    <div className={`flex h-11 shrink-0 select-none items-center justify-between gap-3 border-b border-white/10 bg-[#0D1B2A] px-3 ${dragProps ? 'cursor-grab active:cursor-grabbing' : ''}`}
      {...(dragProps || {})} data-testid="mm-titlebar">
      <div className="flex min-w-0 items-center gap-2.5">
        <ShieldCheck className="h-4 w-4 shrink-0 text-[#22C55E]" />
        <span className="truncate text-sm font-semibold text-white" data-testid="mm-window-title">{title}</span>
        <Elapsed since={since} />
        <span className="flex items-center gap-1 text-xs text-slate-400"><Users className="h-3.5 w-3.5" />{people}</span>
      </div>
      <div className="flex shrink-0 items-center gap-1.5">
        <div className="flex items-center rounded-lg bg-black/30 p-0.5" data-testid="mm-view-toggle">
          <button type="button" className={seg(view === 'speaker')} onClick={() => setView('speaker')} data-testid="mm-view-speaker" title="Speaker view">
            <UserSquare2 className="h-3.5 w-3.5" />{!narrow && 'Speaker'}
          </button>
          <button type="button" className={seg(view === 'gallery')} onClick={() => setView('gallery')} data-testid="mm-view-gallery" title="Gallery view">
            <LayoutGrid className="h-3.5 w-3.5" />{!narrow && 'Gallery'}
          </button>
        </div>
        {pop && (
          <button type="button" className={iconBtn} onClick={pop.open} disabled={!pop.supported} data-testid="mm-ctl-popout"
            title={pop.supported ? 'Pop out into its own window' : 'Pop-out windows work in Chrome and Edge'} aria-label="Pop out">
            <PictureInPicture2 className="h-4 w-4" />
          </button>
        )}
        {onMinimize && (
          <button type="button" className={iconBtn} onClick={onMinimize} data-testid="active-call-minimize" title="Minimize" aria-label="Minimize">
            <Minus className="h-4 w-4" />
          </button>
        )}
      </div>
    </div>
  );
}
